import { query } from '@confluence/query-preloader-tools';

import { useIsAIEnabledForContentQuery } from '../../hooks/useIsAIEnabledForContent';

export function preloadUseIsAIEnabledForContentQuery(contentId: string) {
	return query({
		query: useIsAIEnabledForContentQuery,
		variables: {
			contentId,
		},
	});
}
